import { render } from "./Capacitaciones.vue?vue&type=template&id=16cdeab9&scoped=true"
import script from "./Capacitaciones.vue?vue&type=script&lang=js"
export * from "./Capacitaciones.vue?vue&type=script&lang=js"

import "./Capacitaciones.vue?vue&type=style&index=0&id=16cdeab9&lang=scss&scoped=true"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cdeab9"]])

export default __exports__